import { render, staticRenderFns } from "./EmailOfferCreationPreview.vue?vue&type=template&id=13d04e42&scoped=true&"
import script from "./EmailOfferCreationPreview.vue?vue&type=script&lang=ts&"
export * from "./EmailOfferCreationPreview.vue?vue&type=script&lang=ts&"
import style0 from "./EmailOfferCreationPreview.vue?vue&type=style&index=0&id=13d04e42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d04e42",
  null
  
)

export default component.exports